import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerContent,
  DrawerProps,
  DrawerFooter,
  DrawerOverlay,
} from '@chakra-ui/react';
import { QCloseButton, QRouteTabsProps } from '../../QAtoms';
import { QBox, QStack } from '../../QLayouts';
import { useChakraContainer } from '../../hooks/chakraContainer/chakraContainer';
import { usePartitionedChildren } from '../../utils';
import { QDrawerHeader } from './DrawerHeader';

export interface QDrawerProps
  extends Pick<DrawerProps, 'size' | 'onClose' | 'isOpen' | 'variant'> {
  /**
   * @deprecated
   * Please use `QDrawerHeader` instead.
   */
  title?: string | React.ReactElement;
}

/**
 * This QDrawer is now legacy and is not expected to receive updates.
 * See src/QOrganisms/Drawer/Drawer.tsx for the new version.
 */
export const QDrawer: React.FC<QDrawerProps> = (props) => {
  const { isOpen, onClose, title, size = 'md', children, variant } = props;
  const { chakraContainerRef } = useChakraContainer();

  const {
    QHeader,
    QDrawerHeader: header,
    QDrawerFooter: footer,
    QBadge,
    QRouteTabs,
    unmatched,
  } = usePartitionedChildren(
    children,
    'QHeader',
    'QDrawerHeader',
    'QDrawerFooter',
    'QBadge',
    'QRouteTabs',
  );

  const trapFocus = variant !== 'clickThrough';

  const stickyTabsFix =
    QRouteTabs.length > 0 &&
    QRouteTabs.some((tab) => (tab.props as QRouteTabsProps).sticky !== false);

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      size={size}
      autoFocus={false}
      closeOnOverlayClick={true}
      variant={variant}
      blockScrollOnMount={true}
      trapFocus={trapFocus}
      portalProps={{ containerRef: chakraContainerRef }}
    >
      {variant !== 'clickThrough' && <DrawerOverlay bg="blackAlpha.400" />}
      <DrawerContent>
        <DrawerHeader bgColor="white">
          <QStack direction="row" alignItems="end" spacing="4px">
            {QBadge}
          </QStack>
          {QHeader.length > 0 && QHeader}
          {header.length > 0 && header}
          {!QHeader.length && !header.length && (
            <QDrawerHeader>
              {title}
              <QCloseButton onClick={onClose} />
            </QDrawerHeader>
          )}
          {
            /* This is a fix to keep tab content from being visible above the tabs themselves. */
            stickyTabsFix && <QBox h={2} />
          }
        </DrawerHeader>
        <DrawerBody paddingTop={stickyTabsFix ? 0 : undefined}>
          {QRouteTabs}
          {unmatched}
        </DrawerBody>
        {footer.length > 0 && <DrawerFooter padding={0}>{footer}</DrawerFooter>}
      </DrawerContent>
    </Drawer>
  );
};
